import react from "react";
import Request from "../../../../api/Requests";
import axios from 'axios';


const getEventTicketsPurchased = (params) => {
    return Request('events/event-list-tickets-purchased', 'GET', params, true);
}


const getEventTicketsTransactionList = (params) => {
    return Request('events/event-list-tickets-transactions', 'GET', params, true);
}








export default {
    getEventTicketsPurchased,
    getEventTicketsTransactionList
}